import { createSlice } from '@reduxjs/toolkit';

const favouritesSlice = createSlice({
  name: 'favourites', 
  initialState: {
    items: [] // product_id listesi
  },
  reducers: {
    setFavourites: (state, action) => {
      state.items = action.payload;
    },
    addFavourite: (state, action) => { 
      state.items.push(action.payload);
    },
    removeFavourite: (state, action) => {
      state.items = state.items.filter(id => id !== action.payload);
    },
    clearFavourites: (state) => {
    state.items = [];
    }

  }
});

export const { setFavourites, addFavourite, removeFavourite, clearFavourites } = favouritesSlice.actions;
export default favouritesSlice.reducer;
